import styled from "styled-components";

export const Wrapper = styled.div`
  width: 80%;
  padding-bottom: 8px;
  & > div:first-child {
    margin-bottom: 6px;
  }
`;
